// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"footer-module--footerWrapper--1LCAo","footer":"footer-module--footer--3YcZG","copy":"footer-module--copy--2OqPp","header":"footer-module--header--oSO5u"};